import type { CSSProperties } from 'react';
import { minBreakpoints, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, smallElevation } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { CATEGORY_CARD_MEDIUM_IMAGE_SIZE, CATEGORY_CARD_SMALL_IMAGE_SIZE } from '../constants';

export interface BackgroundColorCSSProperties extends CSSProperties {
  '--backgroundColor': string;
}

const { responsiveText, spacing } = theme;

export const link = css`
  display: grid;
  border-radius: ${pxToRem(10)};
  text-decoration: none;
  width: ${pxToRem(CATEGORY_CARD_SMALL_IMAGE_SIZE)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: ${pxToRem(CATEGORY_CARD_MEDIUM_IMAGE_SIZE)};
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      &:hover {
        ${smallElevation};
      }
    `,
  )}
`;

export const image = css`
  border-top-left-radius: ${pxToRem(10)};
  border-top-right-radius: ${pxToRem(10)};
  object-fit: cover;
  height: ${pxToRem(CATEGORY_CARD_SMALL_IMAGE_SIZE)};
  overflow: hidden;
  display: block;
  width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      height: ${pxToRem(CATEGORY_CARD_MEDIUM_IMAGE_SIZE)};
    `,
  )}
`;

export const categoryTitle = css`
  background-color: var(--backgroundColor, #f5eee5);
  padding: ${spacing.md}px;
  margin: 0;
  height: ${pxToRem(88)};
  color: var(--neutral-black-base);
  ${primarySemiBoldFont};
  ${responsiveText.BODY.MD};
  border-bottom-left-radius: ${pxToRem(10)};
  border-bottom-right-radius: ${pxToRem(10)};
`;
